<template>
    <div class="Apps_Wrapper mb-3 mt-3">

        <!-- <div class="mb-3" v-if="getActiveObj.type !== 'newsApp'">
            <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                Dimensions
                <span class="text-gray-500">(px)</span>
            </label>
            <div class="d-flex align-items-center my-2">
                <div class="mr-3">W</div>
                <div> <input type="text" class="form-control " :value="width" /></div>
                <div class="mx-3">H</div>
                <div><input type="text" class="form-control " :value="height" /></div>
            </div>
        </div>
        <div v-if="getActiveObj.type !== 'newsApp'">
            <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                Coordinates
                <span class="text-gray-500">(px)</span>
            </label>
            <div class="d-flex align-items-center my-2">
                <div class="mr-3">X</div>
                <div> <input type="text" class="form-control " :value="xCoor"/></div>
                <div class="mx-3">Y</div>
                <div><input type="text" class="form-control " :value="yCoor" /></div>
            </div>
        </div> -->
        <div class="App_Settings_wrapper ">
           <YoutubeAppSettings v-if="getActiveObj.type === 'youtubeApp'" />
           <VimeoAppSettings v-else-if="getActiveObj.type === 'vimeoApp'" />
           <NewsAppSettings v-else-if="getActiveObj.type === 'newsApp'" />
           <ClockAppSettings v-else-if="getActiveObj.type === 'clockApp'" />
           <CalendarAppSettings v-else-if="getActiveObj.type === 'calendarApp'" />
           <CountdownSettings v-else-if="getActiveObj.type === 'countdownApp'" />

           <WebPageSettings v-else-if="getActiveObj.type === 'webpageApp'" />
           <qrCodeAppSettings v-else-if="getActiveObj.type === 'qrCodeApp'" />
           <WeatherAppSettings v-else-if="getActiveObj.type === 'weatherApp'" />
        </div>
    </div>
   
</template>
<script>
import YoutubeAppSettings from "../AppsSettings/YoutubeAppSetting.vue";
import VimeoAppSettings from "../AppsSettings/VimeoAppSetting.vue";
import NewsAppSettings from "../AppsSettings/NewsAppSettings.vue";
import ClockAppSettings from "../AppsSettings/ClockAppSettings.vue"
import CalendarAppSettings from "../AppsSettings/CalendarSettings.vue"
import WebPageSettings from "../AppsSettings/WebPageAppSetting.vue"
import qrCodeAppSettings from "../AppsSettings/QRcodeAppSettings.vue"
import WeatherAppSettings from "../AppsSettings/WeatherAppSettings.vue"
import CountdownSettings from "../AppsSettings/CountdownSettings.vue";

export default {
    name: "AppsTab",
    components:{
        YoutubeAppSettings,
        VimeoAppSettings,
        NewsAppSettings,
        ClockAppSettings,
        CalendarAppSettings,
        WebPageSettings,
        qrCodeAppSettings,
        WeatherAppSettings,
        CountdownSettings
    },
    data(){
        return{
            width:"",
            height:"",
            xCoor:"",
            yCoor:""
        }
    },
    computed: {
        getActiveObj() {
            return this.$store.getters.getActiveObjectprops
        },
    },
    watch:{
        getActiveObj(newValues){
            console.log("ActiveObject Props:", newValues)
            // this.width = newValues.width.toFixed(2);
            // this.height = newValues.height.toFixed(2);
            // this.xCoor = newValues.left.toFixed(2);
            // this.yCoor = newValues.top.toFixed(2);
        }
    }
}
</script>